//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue       from 'vue';
import Component from 'vue-class-component';
import Cover     from '@/components/Cover.vue';
import About     from '@/components/About.vue';

@Component({
	metaInfo   : {
		title         : 'Tropical Tower Wars',
		titleTemplate : null,
	},
	components : {
		Cover,
		About,
	},
})
export default class Home extends Vue {}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<div>
	<Cover />
	<About />
</div>
</template>
